import { render } from "./HomeTimeline.vue?vue&type=template&id=3ca21134&scoped=true"
import script from "./HomeTimeline.vue?vue&type=script&lang=js"
export * from "./HomeTimeline.vue?vue&type=script&lang=js"

import "./HomeTimeline.vue?vue&type=style&index=0&id=3ca21134&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca21134"]])

export default __exports__